import { Reveal } from './Reveal'

interface SectionHeadingProps {
  index: string
  title: string
  accent?: string
  blurb?: string
}

export function SectionHeading({ index, title, accent, blurb }: SectionHeadingProps) {
  return (
    <Reveal className="mb-10 flex flex-col gap-4">
      <span className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
        <span className="text-primary">{index}</span>
        <span className="h-px w-10 bg-border" />
      </span>
      <h2 className="font-display text-[clamp(2.25rem,6vw,4.5rem)] font-semibold leading-[0.95] tracking-tighter">
        {title} {accent && <span className="font-accent font-normal italic tracking-normal text-gradient">{accent}</span>}
      </h2>
      {blurb && <p className="max-w-xl text-base text-muted-foreground">{blurb}</p>}
    </Reveal>
  )
}
